(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ei-bamboo-planner"]) return;
  try {
    
(() => {
  const roundUnits = (amount, width) => Math.ceil((amount * 1000 - 0.0000001) / width);
  function calculate(rows, products, caps) {
    const result = { rows: [], groups: [], panelCount: 0, capCount: 0, coverage: 0, total: 0, valid: false, issues: [] };
    const groups = new Map();
    const add = (item, count, type) => {
      const key = String(item.id);
      const group = groups.get(key) || { ...item, count: 0, type };
      group.count += count;
      groups.set(key, group);
    };
    rows.forEach((row, index) => {
      const item = products.find(product => product.key === row.product);
      const line = { index, count: 0, caps: 0, total: 0, coverage: 0, error: null, empty: row.amount.trim() === '' };
      result.rows.push(line);
      if (line.empty) return;
      const amount = Number(row.amount);
      if (!item || !Number.isFinite(amount) || amount <= 0 || amount > 1000 || (row.mode === 'quantity' && !Number.isInteger(amount))) { line.error = 'invalid'; return; }
      if (!item.available) { line.error = 'unavailable'; return; }
      line.count = row.mode === 'quantity' ? amount : roundUnits(amount, item.width);
      line.coverage = line.count * item.width / 1000;
      line.total = line.count * item.price;
      if (row.capping) {
        const cap = caps.find(value => value.colour === item.colour);
        if (!cap || !cap.available) { line.error = 'cap_unavailable'; return; }
        const runLength = row.mode === 'quantity' ? line.coverage : amount;
        line.caps = roundUnits(runLength, cap.length);
        line.total += line.caps * cap.price;
        add(cap, line.caps, 'cap');
        result.capCount += line.caps;
      }
      add(item, line.count, 'panel');
      result.panelCount += line.count;
      result.coverage += line.coverage;
      result.total += line.total;
    });
    result.groups = [...groups.values()].sort((a, b) => a.type === b.type ? 0 : a.type === 'panel' ? -1 : 1);
    result.groups.forEach(item => {
      const limit = item.limit === null ? Infinity : Number(item.limit);
      const ruleMax = item.max === null ? Infinity : Number(item.max);
      if (item.count > limit || item.count > ruleMax || item.count < item.min || item.count % item.step !== 0) result.issues.push(item);
    });
    result.valid = result.panelCount > 0 && !result.rows.some(row => row.error) && !result.issues.length;
    return result;
  }
  class BambooPlanner extends HTMLElement {
    static calculate = calculate;
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.products = JSON.parse(this.querySelector('[data-planner-products]').textContent);
      this.caps = JSON.parse(this.querySelector('[data-planner-capping]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-planner-strings]').textContent);
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD' });
      this.counter = 0;
      this.busy = false;
      this.locked = false;
      this.addEventListener('click', event => {
        const add = event.target.closest('[data-add-run]');
        const remove = event.target.closest('[data-remove-run]');
        const plan = event.target.closest('[data-plan]');
        if (add && !this.locked && !this.busy) this.addRun();
        if (remove && !this.locked && !this.busy) {
          const run = remove.closest('.bp-run');
          const next = run.nextElementSibling || run.previousElementSibling;
          run.remove();
          if (!this.querySelector('.bp-run')) this.addRun();
          this.renumber();
          this.update();
          (next?.querySelector('select') || this.querySelector('[data-add-run]')).focus();
        }
        if (plan && !this.locked && !this.busy) {
          const empty = [...this.querySelectorAll('.bp-run')].find(run => !run.querySelector('[data-field="amount"]').value);
          const run = empty || this.addRun(plan.dataset.plan, false);
          if (run) {
            run.querySelector('[data-field="product"]').value = plan.dataset.plan;
            this.update();
            run.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
            run.querySelector('[data-field="amount"]').focus({ preventScroll: true });
          }
        }
        if (event.target.closest('[data-add-cart]')) this.addToCart();
      });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-field="amount"]')) this.update();
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-field]')) return;
        if (event.target.dataset.field === 'mode') {
          const run = event.target.closest('.bp-run');
          const quantity = event.target.value === 'quantity';
          const input = run.querySelector('[data-field="amount"]');
          input.value = '';
          input.step = quantity ? '1' : '0.001';
          input.min = quantity ? '1' : '0.001';
          input.inputMode = quantity ? 'numeric' : 'decimal';
          input.placeholder = quantity ? '0' : '0.0';
          run.querySelector('[data-label="amount"]').textContent = this.t(quantity ? 'quantity' : 'length');
        }
        this.update();
      });
      this.classList.add('bp-ready');
      const panelId = new URLSearchParams(window.location.search).get('panel');
      const requestedPanel = this.products.find(item => String(item.id) === panelId);
      this.addRun(requestedPanel?.key || null, false);
    }
    t(key, values = {}) {
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name + '__', String(value)), this.strings[key] || key);
    }
    money(cents) { return this.formatter.format(cents / 100); }
    number(value) { return new Intl.NumberFormat(this.dataset.locale || 'en-AU', { maximumFractionDigits: 3 }).format(value); }
    addRun(key, focus = true) {
      if (this.querySelectorAll('.bp-run').length >= 20) {
        this.querySelector('[data-global-error]').textContent = this.t('max_rows');
        return null;
      }
      const run = this.querySelector('[data-run-template]').content.firstElementChild.cloneNode(true);
      const id = this.id + '-run-' + (++this.counter);
      run.querySelectorAll('[data-field]').forEach(input => {
        input.id = id + '-' + input.dataset.field;
        const label = run.querySelector('[data-label="' + input.dataset.field + '"]');
        if (label) label.htmlFor = input.id;
      });
      const error = run.querySelector('[data-run-error]');
      error.id = id + '-error';
      run.querySelectorAll('[data-field]').forEach(input => input.setAttribute('aria-describedby', error.id));
      const selected = key || this.products.find(item => item.height === 1800 && item.colour === 'dark' && item.available)?.key || this.products.find(item => item.available)?.key;
      if (selected) run.querySelector('[data-field="product"]').value = selected;
      this.querySelector('[data-runs]').append(run);
      this.renumber();
      this.update();
      if (focus) run.querySelector('[data-field="amount"]').focus();
      return run;
    }
    renumber() {
      this.querySelectorAll('.bp-run').forEach((run, index) => {
        const title = this.t('section') + ' ' + (index + 1).toString().padStart(2, '0');
        run.querySelector('[data-run-title]').textContent = title;
        run.querySelector('[data-run-legend]').textContent = title;
        run.querySelector('[data-remove-run]').setAttribute('aria-label', this.t('remove_label', { number: index + 1 }));
      });
    }
    itemName(item) {
      return this.t(item.type === 'cap' ? 'summary_cap' : 'summary_item', { colour: this.t(item.colour), height: this.number(item.height / 1000) });
    }
    currentRows() {
      return [...this.querySelectorAll('.bp-run')].map(run => ({
        product: run.querySelector('[data-field="product"]').value,
        mode: run.querySelector('[data-field="mode"]').value,
        amount: run.querySelector('[data-field="amount"]').validity.badInput ? 'invalid' : run.querySelector('[data-field="amount"]').value,
        capping: run.querySelector('[data-field="capping"]').checked
      }));
    }
    update() {
      const rows = this.currentRows();
      this.plan = calculate(rows, this.products, this.caps);
      const runs = [...this.querySelectorAll('.bp-run')];
      this.plan.rows.forEach((line, index) => {
        const run = runs[index];
        const item = this.products.find(product => product.key === rows[index].product);
        const cap = this.caps.find(value => value.colour === item?.colour);
        run.querySelector('[data-cap-price]').textContent = cap ? this.money(cap.price) + ' ' + this.t('per_panel') : '';
        run.querySelector('[data-run-result]').textContent = line.empty || line.error ? this.t('empty') : this.t('row_result', { count: line.count, coverage: this.number(line.coverage) });
        run.querySelector('[data-cap-result]').textContent = line.caps && !line.error ? this.t('cap_result', { count: line.caps }) : '';
        run.querySelector('[data-line-total]').textContent = line.empty || line.error ? '' : this.money(line.total);
        const error = line.error || (!item?.available ? 'unavailable' : null);
        run.querySelector('[data-run-error]').textContent = error ? this.t(error) : '';
        run.querySelector('[data-field="amount"]').setAttribute('aria-invalid', line.error === 'invalid' ? 'true' : 'false');
      });
      const list = this.querySelector('[data-summary-items]');
      list.replaceChildren();
      if (!this.plan.groups.length) {
        const empty = document.createElement('p');
        empty.className = 'bp-summary-empty';
        empty.textContent = this.t('summary_empty');
        list.append(empty);
      }
      this.plan.groups.forEach(item => {
        const row = document.createElement('div');
        row.className = 'bp-summary-item';
        const details = document.createElement('div');
        const label = document.createElement('strong');
        label.textContent = this.itemName(item);
        const quantity = document.createElement('small');
        quantity.textContent = item.count + ' × ' + this.money(item.price);
        const total = document.createElement('span');
        total.textContent = this.money(item.count * item.price);
        details.append(label, quantity);
        row.append(details, total);
        list.append(row);
      });
      this.querySelector('[data-panel-count]').textContent = this.number(this.plan.panelCount);
      this.querySelector('[data-coverage]').textContent = this.number(this.plan.coverage) + 'm';
      this.querySelector('[data-cap-count]').textContent = this.number(this.plan.capCount);
      this.querySelector('[data-subtotal]').textContent = this.money(this.plan.total);
      this.querySelector('[data-add-cart]').disabled = !this.plan.valid || this.busy || this.locked;
      this.querySelector('[data-global-error]').textContent = this.plan.issues.map(item => this.t('stock_error', { item: this.itemName(item) })).join(' ');
      this.querySelector('[data-large-order]').hidden = this.plan.panelCount <= 35;
      clearTimeout(this.liveTimer);
      this.liveTimer = setTimeout(() => {
        this.querySelector('[data-live-total]').textContent = this.plan.panelCount + ' ' + this.t('panels') + '. ' + this.t('subtotal') + ': ' + this.money(this.plan.total);
      }, 600);
    }
    setBusy(value) {
      this.busy = value;
      this.querySelectorAll('.bp-run').forEach(run => { run.disabled = value || this.locked; });
      this.querySelector('[data-add-run]').disabled = value || this.locked;
      this.querySelectorAll('[data-plan]').forEach(button => { button.disabled = value || this.locked; });
      this.querySelector('[data-add-cart]').disabled = value || this.locked || !this.plan.valid;
      this.querySelector('[data-add-cart]').textContent = this.t(value ? 'adding' : this.locked ? 'view_cart' : 'add_cart');
      if (this.locked) this.querySelector('[data-add-cart]').hidden = true;
    }
    async addToCart() {
      if (this.busy || this.locked || !this.plan?.valid) return;
      this.update();
      if (!this.plan.valid) return;
      this.setBusy(true);
      const status = this.querySelector('[data-cart-status]');
      status.textContent = '';
      const root = this.dataset.rootUrl;
      let currentCart;
      try {
        const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error();
        currentCart = await response.json();
      } catch {
        status.textContent = this.t('cart_read_error');
        this.setBusy(false);
        return;
      }
      for (const item of this.plan.groups) {
        const existing = currentCart.items.filter(line => String(line.variant_id) === String(item.id)).reduce((total, line) => total + line.quantity, 0);
        const combined = existing + item.count;
        if ((item.limit !== null && combined > item.limit) || (item.max !== null && combined > item.max)) {
          status.textContent = this.t('cart_stock_error', { item: this.itemName(item) });
          this.querySelector('[data-view-cart]').hidden = false;
          this.setBusy(false);
          return;
        }
      }
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.plan.groups.map(item => ({ id: item.id, quantity: item.count })) })
        });
        const data = await response.json();
        this.locked = true;
        if (!response.ok || data.status) {
          status.textContent = this.t('cart_changed') + (typeof data.description === 'string' ? ' ' + data.description : '');
        } else {
          status.textContent = this.t('added');
          this.querySelector('[data-cart-help]').textContent = this.t('edit_after_add');
        }
      } catch {
        this.locked = true;
        status.textContent = this.t('cart_error');
      } finally {
        this.querySelector('[data-view-cart]').hidden = false;
        this.setBusy(false);
        this.querySelector('[data-view-cart]').focus();
      }
    }
    disconnectedCallback() { clearTimeout(this.liveTimer); }
  }
  if (!customElements.get('ei-bamboo-planner')) customElements.define('ei-bamboo-planner', BambooPlanner);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
